module.exports = __webpack_public_path__ + "img/EconomyTabSelected_ua.3b49da93.webp";